<template>
    <div v-if="section.is_active">
        <h2 class="text-28 lg:text-36 text-navy font-bold mt-10 mb-2" id="brand_and_reputation">Brand &amp; Reputation</h2>
        <div class="hidden lg:flex relative">
            <div class="flex gap-x-2 items-end absolute -top-4 z-10 right-8">
                <img 
                    src="/proposal-presentation-files/img/reviews.png" 
                    alt="Reviews" 
                    class="duration-500 hover:scale-110 cursor-pointer"
                    style="max-height: 250px"
                    @click="enlargeImage"
                >
            </div>
        </div>
        <div class="bg-white shadow p-6 lg:p-8 tr-box lg:mt-4 lg:mb-20">
            <ul class="tr-bullets ml-4 flex flex-col gap-y-2 lg:gap-y-4 mb-8 lg:mb-0 lg:max-w-lg xl:max-w-3xl">
                <li v-for="(bullet, index) in bullets" :key="index" v-html="bullet"></li>
            </ul>
        </div>
        <div class="flex lg:hidden justify-center">
            <img 
                src="/proposal-presentation-files/img/review.png" 
                alt="Reviews" 
                class="relative shadow -mt-8 cursor-pointer" 
                style="max-height: 150px"
                @click="enlargeImage"
            >
        </div>

        <proposal-modal-image
            v-if="modalImage"
            :modal-image-url="modalImageUrl"
            :modal-image-container="modalImageContainer"
            @close="modalImage = false"
        />
    </div>
</template>

<script>
import ProposalModalImage from "./proposal-modal-image";
import sellingPointMixin from '../sellingPointMixin';

export default {
    components: {
        ProposalModalImage,
    },
    mixins: [
        sellingPointMixin
    ],
    props: [
        'section',
    ],
    computed: {
        bullets() {
            return this.formatBullets(this.section.content);
        },
    },
}
</script>